<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Number -->
    <apartment-number-from-field
      v-model="$attrs.apartment.apartment_number_from"
      :error="$attrs.errors.apartment.apartment_number_from"
    />

    <!-- Number -->
    <apartment-number-to-field
      v-model="$attrs.apartment.apartment_number_to"
      :error="$attrs.errors.apartment.apartment_number_to"
    />

    <!-- Number -->
    <contract-number-prefix-field
      v-model="$attrs.apartment.contract_number_prefix"
      :error="$attrs.errors.apartment.contract_number_prefix"
    />

    <!-- Block -->
    <block-field
      v-model="$attrs.apartment.block"
      :error="$attrs.errors.apartment.block"
      v-show="!(formType == 'add' && $attrs.apartment.block)"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import apartmentNumberFromField from '@/components/forms/apartment/fields/FromApartmentNumber'
import apartmentNumberToField from '@/components/forms/apartment/fields/ToApartmentNumber'
import blockField from '@/components/forms/apartment/fields/Block'
import contractNumberPrefixField from '@/components/forms/apartment/fields/ContractNumberPrefix'

export default {
  name: 'apartment-bulk-add-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    formType: {
      type: String,
      required: true
    }
  },
  components: {
    apartmentNumberFromField,
    apartmentNumberToField,
    blockField,
    contractNumberPrefixField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ApartmentBulkAddBlankForm.vue?56187e62